<template>
  <div>
    <Header theme="white" @setScroll="setScroll"></Header>
    <div class="banner">
      <div class="word">
        <div style="font-size: 42px;font-family: Source Han Sans CN;color: #FFFFFF;line-height: 46px;">
          政策支持
        </div>
        <div style="font-size: 16px;font-family: Adobe Heiti Std;color: #FFFFFF;line-height: 46px;">
          / Policy Support
        </div>
      </div>
    </div>
    <div class="newList">
      <!-- <div style="font-size: 16px;border-bottom: 1px solid #E1E1F0;width: 100%;">
        <div style="margin-bottom: 16px;">
          <span style="color: #ABB8C9;">首页 ></span><span style="color: #36444D"> 政策支持</span>
        </div>
      </div> -->
      <div id="news">
        <div style="display: flex;justify-content: flex-start;flex-wrap: wrap">
          <div class="list" v-for="(item, index) in PageList" :key="index"
            style="box-shadow: 0px 2px 10px 0px rgba(220,221,236,0.5);border-radius: 8px;width: 396px;height: 320px;margin: 0 30px 30px;cursor: pointer;"
            @click="toDetails(item.id)">
            <img :src="baseUrl + item.image" style="width: 395px;height: 200px;border-radius: 8px;">
            <div style="display: flex;align-items: center;padding: 6px 12px;">
              <img src="../../assets/images/time.png" style="width: 16px;height: 16px;margin-right: 5px;">
              <span
                style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #767D8A;">{{item.publishTime}}</span>
            </div>
            <div style="padding: 6px 12px;box-sizing: border-box;font-size: 18px;font-family: Source Han Sans CN;font-weight: 400;color: #121E30;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow:hidden;text-overflow:ellipsis;height: 56px;">
              {{item.contentTitle}}
            </div>
          </div>
        </div>
      </div>
      <Paging @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :currentPage="pageNum"
        :loading="loading" :pageSize="pageSize" :total="total"></Paging>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import Paging from "@/components/common/commonTable";
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    getArticleData
  } from '@/api/api'
  export default {
    data() {
      return {
        scroll: 'home',
        PageList: [],
        loading: false,
        baseUrl: '',
        pageNum: 0,
        pageSize: 9,
        loading: false,
        total: 0,
      }
    },
    components: {
      Header,
      Footer,
      Paging
    },
    mounted() {
      this.baseUrl = serverUrl.baseURL
      this.getpolicyList()
    },
    methods: {
      toDetails(id) {
        this.$router.push({
          path: "/PolicyDetails",
          query: {
            data: id
          },
        })
      },
      setScroll(eId) {
        this.scroll = eId
      },
      getpolicyList() {
        let params = {
          type: 3,
          page: this.pageNum >= 1 ? this.pageNum - 1 : this.pageNum,
          size: this.pageSize
        }
        getArticleData(params).then(res => {
          this.PageList = res.data.content
          this.total = Number(res.data.totalElements)
        })
      },
      //当前页变更
      handleCurrentChange(num) {
        this.pageNum = num
        this.getpolicyList();
      },
      //当前页查询数据条数变更
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.currentPage = 1;
        this.getpolicyList();
      },
    }
  }
</script>

<style scoped>
  .banner {
    width: 100%;
    height: 478px;
    background: url(../../assets/images/zczc@2x.png) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }

  .sidebar {
    width: 1337px;
    margin: 0 auto;
  }

  .newList {
    width: 1373px;
    margin: 40px auto 0;
  }

  .word {
    width: 1337px;
    margin: 100px auto 0;
  }

  .contain {
    overflow-x: hidden;
    font-size: 16px;
    height: 100vh;
    font-family: PingFang-SC-Medium, PingFang-SC !important;
  }

  ::-webkit-scrollbar {
    display: none !important;
    /* Chrome */
  }

  /deep/ .sidebarLeft .el-tabs__active-bar {
    position: absolute;
    top: 0px;
    right: 0;
    height: 20px;
    background: #1E65F2;
    border-radius: 3px;
    z-index: 1;
  }

  .line {
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  #news {
    height: 102%;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/policy/PolicyList.vue